// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Timer_timers__NXAjI {\n  background: honeydew;\n}\n\n.Timer_timer__7dWP1 {\n  display: inline-block;\n  padding: 2px;\n  border: 1px solid gray;\n  margin-left: 5px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Timer.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB","sourcesContent":[".timers {\n  background: honeydew;\n}\n\n.timer {\n  display: inline-block;\n  padding: 2px;\n  border: 1px solid gray;\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timers": "Timer_timers__NXAjI",
	"timer": "Timer_timer__7dWP1"
};
export default ___CSS_LOADER_EXPORT___;
